import { createFileRoute, redirect } from "@tanstack/react-router";
import { TicketCreateForm } from "@/features/tickets/TicketCreateForm";
import { canCreateTicket } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/tickets/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateTicket(me.roles)) {
      throw redirect({ to: "/tickets" });
    }
  },
  component: NewTicketPage,
});

function NewTicketPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Create Ticket</h1>
        <p className="text-sm text-muted-foreground">Report an asset, facility or IT issue. Cross-department reporting is allowed.</p>
      </header>
      <TicketCreateForm mode="manual" source="Manual" />
    </div>
  );
}
